import type { IconSvgObject } from './types';

const WeightScaleIcon: IconSvgObject = [
  ["path", { d: "M15.847 3H8.15301C7.54446 3 7.077 3.53899 7.16306 4.14142L7.93867 9.57071C7.97386 9.81704 8.18482 10 8.43365 10H15.5664C15.8152 10 16.0261 9.81704 16.0613 9.57071L16.8369 4.14142C16.923 3.53899 16.4555 3 15.847 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 6H18C19.1046 6 20 6.89543 20 8V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V8C4 6.89543 4.89543 6 6 6H7.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 17H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 10L12.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default WeightScaleIcon;
